import ModelCreation from "./QuantModelCreation";

export default ModelCreation;
